import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';

import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { FORM_ERROR } from 'final-form';
import { Link } from 'react-router';


import { createCompanyUser2, companyUserCreated } from 'actions/company';
import NotFound from 'components/NotFound';
import NavBarConfig from 'components/NavBarConfig';
import CompanyUserCreate from 'components/companyUser/CompanyUserCreate';
import {unsubscribe} from "actions/ot_signaling";

const messages = defineMessages({
  BACK: {
    id: 'CompanyUserCreatePage.BACK',
    defaultMessage: 'Zurück',
  },
  CREATE_NEW_USER: {
    id: 'CompanyUserCreatePage.CREATE_NEW_USER',
    defaultMessage: 'Neuen Benutzer anlegen',
  },
});

function CompanyUserCreatePage({
  user,
  company,
  companyMembership,
  onSubmit,
  routes,
  intl: { formatMessage },
}) {
  if (!company || !companyMembership) { return null; }
  if (!user.is_admin && !companyMembership.is_owner && !companyMembership.is_admin) {
    return <NotFound />;
  }
  return (
    <div style={{ backgroundColor: 'transparent', minHeight: '100vh', width: '100%', padding: '16px' }}>
      <NavBarConfig
          companyUserListunsubscribe
          createPage
          currentRouteName={routes[routes.length - 1].name}
      />
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ maxWidth: '700px' }}>
          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
            <Link to={`/company/${company.id}/user/`} onMouseDown={e => e.preventDefault()} style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: 'var(--btn-default-bg)', border: '1px solid var(--btn-default-border)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-color)', textDecoration: 'none' }}>
              <i className="fa fa-arrow-left" />
            </Link>
            <h2 style={{ margin: 0, fontSize: '28px', fontWeight: 'bold', color: 'var(--text-color)' }}>
              {formatMessage(messages.CREATE_NEW_USER)}
            </h2>
          </div>
          
          {/* Main Card */}
          <div style={{ backgroundColor: 'var(--panel-bg)', borderRadius: '16px', border: '1px solid var(--panel-border)', boxShadow: '0 4px 6px -1px var(--panel-shadow)', padding: '32px' }}>
            <CompanyUserCreate
              onSubmit={onSubmit}
              is_admin={user.is_admin}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect(
  state => state.companySingle,
  (dispatch, props) => ({
    onSubmit: async formData => {
      const data = await createCompanyUser2(props.params.companyId, {
        ...formData,
        email: formData.email || undefined,
        phone: formData.phone || undefined,
      });
      if (data.response) {
        const companyUser = data.response;
        dispatch(companyUserCreated(companyUser));
        dispatch(push(`/company/${companyUser.company_id}/user/`));
      } else {
        return { [FORM_ERROR]: data.error[Object.keys(data.error)[0]] };
      }
   }
  }),
)(injectIntl(CompanyUserCreatePage));
